import { useEffect, useState } from "react";
import { adminApi } from "@/lib/api";
import { fmtDate, fmtNum, Panel, PageHeader, Th, Td, Empty } from "@/components/admin/parts";

export default function NoMatchStats() {
  const [data, setData] = useState(null);

  useEffect(() => {
    adminApi.noMatchStats().then(setData).catch(() => setData({ items: [], total: 0 }));
  }, []);

  return (
    <div data-testid="admin-no-match-page">
      <PageHeader
        title="Braki asystenta"
        subtitle="Zagregowane potrzeby bez dopasowania (typ + licznik). Nie zapisujemy treści zapytań ani danych użytkowników."
      />
      <div
        data-testid="admin-assistant-coverage-note"
        className="mb-6 rounded-panel border border-brand-line bg-brand-surface p-4 text-sm text-brand-sec"
      >
        <span className="font-semibold text-brand-text">Asystent Promptivo — MVP v1.</span>{" "}
        Deterministycznie i precyzyjnie obsługujemy <span className="font-semibold text-brand-text">248 z 384</span>{" "}
        kreatorów (8 kategorii). Pozostałe pozostają dostępne przez katalog/bibliotekę, ale{" "}
        <span className="font-semibold text-brand-text">nie są przedstawiane jako równie precyzyjnie dopasowane</span>{" "}
        przez Asystenta. Zbieramy wyłącznie zagregowane statystyki (typ potrzeby + licznik), bez treści zapytań.
        Ścieżki dopasowania raportujemy neutralnie jako <span className="font-semibold text-brand-text">„dopasowanie regułami"</span>{" "}
        i <span className="font-semibold text-brand-text">„dopasowanie wspomagane"</span> — to informacja o metodzie, nie o jakości.
      </div>
      <Panel testId="admin-no-match-table">
        {!data ? (
          <Empty>Ładowanie…</Empty>
        ) : data.items.length === 0 ? (
          <Empty>Brak zarejestrowanych braków dopasowania.</Empty>
        ) : (
          <>
            <p className="mb-4 text-sm text-brand-sec" data-testid="admin-no-match-total">
              Łącznie zgłoszeń bez dopasowania: <span className="font-semibold text-brand-text">{fmtNum(data.total)}</span>
            </p>
            <div className="overflow-x-auto">
              <table className="w-full min-w-[560px]">
                <thead>
                  <tr className="border-b border-brand-line">
                    <Th>Typ potrzeby</Th>
                    <Th className="text-right">Liczba</Th>
                    <Th>Ostatnie wystąpienie</Th>
                  </tr>
                </thead>
                <tbody>
                  {data.items.map((r) => (
                    <tr key={r.category} className="border-b border-brand-line/60" data-testid={`admin-no-match-row-${r.category}`}>
                      <Td className="font-medium text-brand-text">{r.label}</Td>
                      <Td className="text-right">{fmtNum(r.count)}</Td>
                      <Td className="whitespace-nowrap text-brand-sec">{r.updated_at ? fmtDate(r.updated_at) : "—"}</Td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </Panel>
    </div>
  );
}
